export function HeartFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 5.683C10.842 4.777 9.185 4 7.5 4 4.724 4 2 6.296 2 9.688c0 1.52.245 2.73.773 3.83.52 1.084 1.285 1.996 2.206 2.956 1.036 1.08 2.713 2.192 4.056 3.004a47.811 47.811 0 002.454 1.383l.04.021.01.006.005.002L12 20l-.456.89c.286.146.626.147.912 0L12 20l.456.89.004-.002.011-.006.04-.02.15-.079c.128-.068.313-.166.54-.29.453-.248 1.078-.6 1.764-1.015 1.343-.812 3.02-1.925 4.056-3.004.921-.96 1.685-1.872 2.206-2.955.528-1.101.773-2.31.773-3.832C22 6.297 19.276 4 16.5 4c-1.685 0-3.342.777-4.5 1.683z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
